/**
 * @generated SignedSource<<2be5a6d0d5481f5768efd2c04a31450b>>
 * @relayHash 2b75fc1121e53c1c0a5ad6a53dc0d745
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da67c9639926a2efc46d2b199b1e767f62d394339ad04fad1158a6e32d14ceab

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLCoverPictureWidth = "FIXED" | "FULL" | "%future added value";
export type EditorPageCoverPictureUpdateCoverPictureWidthMutation$variables = {
  contentId: string;
  coverPictureWidth: GraphQLCoverPictureWidth;
};
export type EditorPageCoverPictureUpdateCoverPictureWidthMutation$data = {
  readonly updateCoverPictureWidth: {
    readonly content: {
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type EditorPageCoverPictureUpdateCoverPictureWidthMutation = {
  response: EditorPageCoverPictureUpdateCoverPictureWidthMutation$data;
  variables: EditorPageCoverPictureUpdateCoverPictureWidthMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "coverPictureWidth"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "coverPictureWidth",
            "variableName": "coverPictureWidth"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UpdateCoverPictureWidthPayload",
    "kind": "LinkedField",
    "name": "updateCoverPictureWidth",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2b75fc1121e53c1c0a5ad6a53dc0d745",
    "id": "da67c9639926a2efc46d2b199b1e767f62d394339ad04fad1158a6e32d14ceab",
    "metadata": {},
    "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
    "operationKind": "mutation",
    "text": "mutation EditorPageCoverPictureUpdateCoverPictureWidthMutation($contentId:ID!,$coverPictureWidth:GraphQLCoverPictureWidth!){updateCoverPictureWidth(input:{contentId:$contentId,coverPictureWidth:$coverPictureWidth}){content{id}}}"
  }
};
})();

(node as any).hash = "d3df2b12316133bd2b6a3afaae602a82";

export default node;
